import { StringUtils } from "../../../../utils/stringUtils";
import { ReportProps, ValidationError, Validator } from "../../../../types/types";

export class FinalPreviewValidator implements Validator<ReportProps> {
    validate(props: ReportProps): ValidationError[] {

        const reviewMode = props.reportInfo.reviewingStatus === 'REVIEW' ? true : false
        const errors: ValidationError[] = [];

        if (StringUtils.isEmpty(props.reportInfo.reviewer) && reviewMode)
            errors.push(new ValidationError("reviewer", "Please select Report Reviewer name!"))

       return errors;
    }
}